import React from "react";
import SimpleModal from "../../SimpleModal";

export function SelectPOCPopulationPage({
  toggleModalSequence,
  page,
  setPage,
  resetState,
  selectedSection,
  setSelectedSection,
  formPreview: {
    last_name,
    first_name,
    middle_name,
    job_title,
    form_title1,
    form_section_info1,
    section1,
    form_title2,
    form_section_info2,
    section2,
  },
}) {
  return (
    <SimpleModal
      toggleModal={toggleModalSequence}
      modalStatus={page === 1}
      renderButton={() => null}
      minWidth="90%"
      onRequestClose={() => resetState()}
    >
      <div>
        <h3>
          Here's your Requestor POC information from your Prevailing Wage
          determination:
        </h3>
        <p className="selection-label">
          Requestor Point of Contact Information
        </p>

        <dl className="dl-flex">
          <dt>Contact’s Last (family) Name</dt>
          <dd>{last_name || "None provided"}</dd>

          <dt>First (given) Name</dt>
          <dd>{first_name || "None provided"}</dd>

          <dt>Middle Name(s)</dt>
          <dd>{middle_name || "None provided"}</dd>

          <dt>Contact’s Job Title</dt>
          <dd>{job_title || "None provided"}</dd>
        </dl>

        <fieldset className="usa-fieldset">
          <legend>
            <h3 className="margin-top-4">
              Select how this should populate in your Temporary Labor
              Certification Application:
            </h3>
          </legend>

          <div className="box-selector-group">
            <div
              onClick={() => setSelectedSection(section1)}
              onKeyUp={(e) => {
                if (e.key === " ") setSelectedSection(section1);
              }}
              className={`box-selector ${
                selectedSection === section1 ? "selected" : null
              }`}
            >
              <div className="label">
                <p className="title">{form_title1}</p>
                <p className="form-section">{form_section_info1}</p>
              </div>
              <ul className="usa-input-list">
                <li>
                  <input
                    name="sectionSelection"
                    id="section1"
                    type="radio"
                    checked={selectedSection === section1}
                    onClick={() => setSelectedSection(section1)}
                    className="usa-radio-input"
                  />
                  <label
                    className="usa-radio-label"
                    onClick={(e) => setSelectedSection(section1)}
                    htmlFor="section1"
                    onKeyUp={(e) => {
                      if (e.key === " ") setSelectedSection(section1);
                    }}
                  >
                    {/* <span className="usa-sr-only">Section {section1}</span> */}
                  </label>
                </li>
              </ul>
            </div>

            <div
              onClick={() => setSelectedSection(section2)}
              onKeyUp={(e) => {
                if (e.key === " ") setSelectedSection(section2);
              }}
              className={`box-selector ${
                selectedSection === section2 ? "selected" : null
              }`}
            >
              <div className="label">
                <p className="title">{form_title2}</p>
                <p className="form-section">{form_section_info2}</p>
              </div>
              <ul className="usa-input-list">
                <li>
                  <input
                    name="sectionSelection"
                    id="section2"
                    type="radio"
                    checked={selectedSection === section2}
                    onClick={() => setSelectedSection(section2)}
                    className="usa-radio-input"
                  />
                  <label
                    className="usa-radio-label"
                    onClick={() => setSelectedSection(section2)}
                    htmlFor="section2"
                    onKeyUp={(e) => {
                      if (e.key === " ") setSelectedSection(section2);
                    }}
                  >
                    {/* <span className="usa-sr-only">Section {section2}</span> */}
                  </label>
                </li>
              </ul>
            </div>
          </div>
        </fieldset>

        <div>
          <button
            type="button"
            style={{ marginTop: "15px", float: "left" }}
            className={"usa-button usa-button--outline"}
            onClick={() => setPage(0)}
          >
            Back
          </button>
          <button
            type={"button"}
            className={"usa-button usa-button-primary modal-submit"}
            onClick={() => {
              setPage(2);
            }}
            disabled={!selectedSection}
          >
            Continue{" "}
          </button>
        </div>
      </div>
    </SimpleModal>
  );
}
